import { combineReducers } from 'redux';
import content from './contentReducer';
import personalImg from './personalImgReducer';
import fieldSettings from './fieldSettingsReducer';
import basicInfo, {
  fetchBasicInfoChangeRecords,
  fetchBasicInfoEffectiveData,
} from '../screens/BasicInfo/reducers';
import contactInfo, {
   fetchContactInfoChangeRecords,
   fetchContactInfoEffectiveData,
} from '../screens/ContactInfo/reducers';
import certificationAndEducationInfo, {
  fetchEducationChangeRecords,
  fetchEducationEffectiveData,
  fetchCertificationChangeRecords,
  fetchCertificationEffectiveData,
} from '../screens/CertificationAndEducationInfo/reducers';
import seniorityInfo, { fetchSeniorityInfo } from '../screens/SeniorityInfo/reducers';
import workingRecords, { fetchWorkingRecords } from '../screens/WorkExpInfo/reducers';
import changeRecords, { fetchChangeRecords } from '../screens/JobChangeInfo/reducers';
import params from './paramsReducer';

export default combineReducers({
  personalImg,
  content,
  fieldSettings,
  basicInfo,
  contactInfo,
  certificationAndEducationInfo,
  seniorityInfo,
  workingRecords,
  changeRecords,
  params,
});

export function initialize() {
  return (dispatch) => {
    dispatch(fetchBasicInfoEffectiveData());
    dispatch(fetchBasicInfoChangeRecords());
    dispatch(fetchContactInfoEffectiveData());
    dispatch(fetchContactInfoChangeRecords());
    dispatch(fetchEducationChangeRecords());
    dispatch(fetchEducationEffectiveData());
    dispatch(fetchCertificationChangeRecords());
    dispatch(fetchCertificationEffectiveData());
    dispatch(fetchSeniorityInfo());
    dispatch(fetchWorkingRecords());
    dispatch(fetchChangeRecords());
  };
}



/** WEBPACK FOOTER **
 ** D:/a/1/s/Tube.Frontend/src/containers/App/screens/Foundation/screens/MyData/reducers/index.js
 **/